import { FeedbackButton } from '../feedback/FeedbackButton'
import { NotificationBell } from './NotificationBell'
import { StageBadge } from './StageBadge'
import { useAuth } from '@/contexts/AuthContext'
import { IS_STAGE } from '@/lib/env'

export function TopBarActions() {
  const { isLoading } = useAuth()

  return (
    <div className="flex min-w-0 flex-wrap items-center justify-end gap-1.5">
      {IS_STAGE && <StageBadge />}
      <FeedbackButton />
      {/* Admins included: they own feedback items and are told when a submitter
          answers one, and the bell is also the only place any role can turn on
          push. Hidden until the profile resolves, not per-role. */}
      {!isLoading && <NotificationBell />}
    </div>
  )
}
